module.exports = __webpack_public_path__ + "img/co2.4aa5fdba.svg";